const $ = jQuery.noConflict();

export default class Tabs {
    constructor($wrapper) {
        this.trigger = $wrapper.find('.tab-trigger');
        this.tab = $wrapper.find('.single-tab');
    }

    initTriggers() {
        this.trigger.on('click', e => {
            e.preventDefault();
            this.trigger.removeClass('active');
            this.tab.removeClass('active').hide();

            $(e.target).addClass('active');
            this.tab.filter((i, item) => {
                    if ($(item).attr('id') === $(e.target).attr('href').substring(1, $(e.target).attr('href').length)) {
                        $(item).addClass('active').slideDown(200);
                    }
                }
            );
        })
    }
}
